import { render, staticRenderFns } from "./UploadDocumentHeader.vue?vue&type=template&id=68eec781"
import script from "./UploadDocumentHeader.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports